import { Link, useNavigate } from "react-router-dom";
import notFoundImg from "../../../images/defaultPage/NotFoundImg.png";
import "./NotFound.css";
import { Grid } from "@mui/material";
// import { useEffect, useRef, useState } from "react";

const NotFound = () => {
  const navigate = useNavigate();
  // const [txt, setTxt] = useState("");
  // const inputRef = useRef();
  // const changeHandler = (e) => {
  //   e.preventDefault();

  //   const lfRegex = /\n/g;

  //   const lfMatches = e.target.value.match(lfRegex);

  //   // Check if LF characters were found
  //   if (lfMatches) {
  //     // lfMatches is an array of matched LF characters
  //     console.log("CHANGE* LF characters found:", lfMatches);
  //   } else {
  //     console.log("CHANGE* LF characters not found in the inputRef.current.value.");
  //   }
  //   setTxt(e.target.value);
  // };
  // const keyDownHandler = (e) => {
  //   const lfRegex = /\n/g;

  //   const lfMatches = e.target.value.match(lfRegex);

  //   // Check if LF characters were found
  //   if (lfMatches) {
  //     // lfMatches is an array of matched LF characters
  //     console.log("Key Down* LF characters found:", lfMatches);
  //   } else {
  //     console.log("Key Down* LF characters not found in the inputRef.current.value.");
  //   }
  // };
  return (
    <Grid container className="notFoundImageContainer">
      <img src={notFoundImg} alt="404 Error (NotFound)" className="notFoundImage" />

      <button className="notFoundBtn" onClick={(e) => navigate(-1)}>
        داشبرد مدیریت
      </button>

      {/* <textarea
        ref={inputRef}
        className="aaa"
        onChange={changeHandler}
        onKeyDown={keyDownHandler}
        value={txt}
      /> */}
    </Grid>
  );
};

export default NotFound;
